export enum CriteriaLogic {
  organizationHeadquarters = 'organization-headquarters',
  negativeOrganizationHeadquarters = 'negative-organization-headquarters',
  organizationStage = 'organization-stage',
  organizationFoundedAt = 'organization-founded-at',
}
